
const normalizeThemeName = theme => theme.replace(/\//g, '--');

// getThemeName :: ThemePaths -> String
//    ThemePaths = [String]
const getThemeName = themePaths =>
  themePaths.length ? normalizeThemeName(themePaths[0]) : 'imd-default';

//getActualThemePaths :: ThemePaths -> ThemePaths
const getActualThemePaths = themePaths => themePaths.map(
  themePath => `customize/src/${themePath}`
);

module.exports = {
  normalizeThemeName,
  getThemeName,
  getActualThemePaths
};
